import React from 'react'
import Header from '../../components/header'

const Imprint = () => {
  return (
    <div><>
              <Header hideSearchBar={true} hideAddNew={true} hideHome={true} />

      Imprint
      </>
    </div>
  )
}

export default Imprint
